import ApolloGqlClientImpl from "./internal/apollo-gql-client.ts";
import type {ApolloGqlClient} from "./types.ts";

let instance = null;
/**
 * Get an unsafe `ApolloGqlClient` instance.
 *
 * Use `withApollo` in your components unless you're certain that is not
 * what you need. An unsafe instance, unlike an instance from the
 * `withApollo` HOC, will not be safely mocked in React component trees,
 * such as in fixtures.
 */
export const getUnsafeApolloGqlClient = (): ApolloGqlClient => {
    if (instance == null) {
        // @ts-expect-error - TS2322 - Type 'ApolloGqlClient' is not assignable to type 'null'.
        instance = new ApolloGqlClientImpl();
    }
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'ApolloGqlClient'.
    return instance;
};
